export function jsxIf(condition, trueCase, falseCase = (()=>null) ) {
    if(condition) {
        return trueCase();
    } else {
        return falseCase();
    }
}

export function jsxIfNot(condition, trueCase, falseCase = (()=>null)) {
    if(!condition) {
        return trueCase();
    } else {
        return falseCase();
    }
}

export function jsxWith(object, callback) {
	return callback(object);
}
